import { MpColumnFormatter } from "../../types/Table";

export const toPercent: MpColumnFormatter = ({ value }) => {
  const number: number =
    typeof value === "string" ? parseInt(value, 10) : value;

  return value !== undefined ? `${Math.round(number * 100)}%` : null;
};
